import styled from 'styled-components';
import { themes } from 'kb-shared';

const { colors, fonts } = themes;

export const TitleBase = styled.h3`
  font-size: 36px;
  color: ${colors.KBDarkBlue};
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.22;
  letter-spacing: -0.3px;
  ${fonts.DomaineDisplay};
`;

export const CopyBase = styled.p`
  color: ${colors.KBDarkBlue};
  font-size: 20px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  ${fonts.FoundersGrotesk};
`;

export const CallToActionBase = styled.div`
  display: flex;
  flex-direction: column;
`;
